import { Inject, Injectable } from '@angular/core';

import { lastValueFrom, of } from 'rxjs';

import { GtagEventModel } from '../models/gtag-event.model';

/**
 * Class heavily inspired from https://medium.com/wizdm-genesys/using-gtag-in-angular-b99a10025fcd
 */
@Injectable()
export class GtagService {
    constructor(
        @Inject('gtag') private gtag
    ) {}

    public event(action: string, params?: GtagEventModel): Promise<void> {
        if (!this.gtag) {
            return lastValueFrom(of(undefined));
        }
        // Wraps the event call into a Promise
        return new Promise( (resolve, reject) => {
            try {
                // Triggers a 3s time-out timer
                const tmr = setTimeout( () => reject(new Error('gtag call timed-out')), 10000 );
                // Performs the event call resolving with the event callback
                this.gtag(
                    'event',
                    action,
                    {
                        ...params,
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        event_callback: () => {
                            clearTimeout(tmr);
                            resolve();
                        }
                    }
                );
            } catch(e) {
                reject(e);
            }
        });
    }

    public buttonPress(buttonId: string): Promise<void> {
        return this.event(
            'button_press',
            {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'button_id': buttonId
            }
        );
    }

    public exception(errMessage: string): Promise<void> {
        return this.event(
            'exception',
            {
                'description': errMessage
            }
        );
    }
}
